export default {
    data() {
        return {
            tableHeight: 0,
            isCollapse: true
        }
    },
    watch: {
        isCollapse() {
            this.estimateTableHeight()
        }
    },
    mounted() {
        this.estimateTableHeight()
        window.addEventListener('resize', () => { this.estimateTableHeight() })
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => { this.estimateTableHeight() })
    },
    methods: {
        estimateTableHeight(isCollapsed) {
            this.$nextTick(
                () => {
                    let h = document.documentElement.clientHeight - 160
                    if (this.$refs.searchArea) { // 如果有搜索框则需要减去它的高度
                        h = h - this.$refs.searchArea.$el.offsetHeight
                    }
                    if (this.$refs.buttonArea) { // 如果有上传下载按钮需减去它的高度
                        h = h - this.$refs.buttonArea.$el.offsetHeight
                    }
                    if (this.$refs.breadCrumb) { // 如果有分页区域需减去它的高度
                        h = h - this.$refs.breadCrumb.$el.offsetHeight
                    }
                    this.tableHeight = h > 310 ? h : 310 // 根据自己项目定高度
                    return h
                }
            )
        }
    }
}